import { render, staticRenderFns } from "./SylvanaWaiting3.vue?vue&type=template&id=2e7e5c84&"
import script from "./SylvanaWaiting3.vue?vue&type=script&lang=ts&"
export * from "./SylvanaWaiting3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports